import { useState } from "react"
import PropTypes from "prop-types"
import FilterButton from "./FilterButton"
import FilterBadgeContent from "./FilterBadgeContent"
import { Checkbox } from "components/ui"
import { isBlank, isPresent } from "utils/helpers"

const flattenAddOns = (selected, options) =>
  options.reduce(
    (arr, addOn) =>
      addOn.variations.length > 0
        ? arr.concat(
            addOn.variations.map(variation => ({
              ...variation,
              type: "variation",
              isChecked: selected.extra && selected.extra.includes(variation.id.toString())
            }))
          )
        : arr.concat({
            ...addOn,
            type: "addOn",
            isChecked: selected.value && selected.value.includes(addOn.id.toString())
          }),
    []
  )

export const ADD_ON_KIND = "addOn"

export const addOnBadge = (selected, options) => {
  const names = flattenAddOns(selected, options)
    .filter(o => o.isChecked)
    .map(o => o.name)

  return <FilterBadgeContent label="Add-on" value={names.join(", ")} />
}

const AddOnOptions = ({ onSubmit, options = [] }) => {
  const [value, setValue] = useState([])
  const [extra, setExtra] = useState([])

  const handleSelect = (e, selectedOption) => {
    if (e.target.checked) {
      selectedOption.type === "addOn"
        ? setValue([...value, selectedOption.id.toString()])
        : setExtra([...extra, selectedOption.id.toString()])
    } else {
      selectedOption.type === "addOn"
        ? setValue(value.filter(v => v !== selectedOption.id.toString()))
        : setExtra(extra.filter(v => v !== selectedOption.id.toString()))
    }
  }

  const handleSubmit = () => {
    onSubmit({
      ...(isPresent(value) && { value }),
      ...(isPresent(extra) && { extra }),
      label: addOnBadge({ value, extra }, options),
      kind: ADD_ON_KIND
    })

    setValue([])
    setExtra([])
  }

  const addOnOptions = flattenAddOns({ value, extra }, options)

  return (
    <>
      <h5 className="m-0 label">Include</h5>
      {addOnOptions.map(o => (
        <Checkbox
          key={`${o.type}-${o.id}`}
          name={`addOn_${o.type}_${o.id}`}
          htmlFor={`addOn_${o.type}_${o.id}`}
          text={o.name}
          value={o.id.toString()}
          checked={o.isChecked}
          onSelect={e => handleSelect(e, o)}
          labelClasses="mb-1 ws-n"
        />
      ))}
      <FilterButton disabled={isBlank(value) && isBlank(extra)} onSubmit={handleSubmit} />
    </>
  )
}

AddOnOptions.propTypes = {
  onSubmit: PropTypes.func,
  options: PropTypes.array
}

export default AddOnOptions
